import events from '../shared/events';

export function tesOrderControlInteraction(label) {
    events._orderControlInteractionLabel('TES Order Control', label);
}
